export const MOCK: Object = {};



// WEBPACK FOOTER //
// ./src/app/constants/mock.ts